import React, {useState} from 'react';
import {Form} from "react-bootstrap";

const TransactionRow = ({r, cb}) => {
  const [entityNumbers, setEntityNumbers] = useState('')
  const sendInfo = (r) =>{
    const {sheetTitle,sheetId,numberString,year,KZT,USD,EUR,date} = r
    if(entityNumbers.length>0){
      cb({
        entityNumbers,
        year,
        transactions: {
          KZT,
          USD,
          EUR
        },
        title: sheetTitle,
        sheetId,
        date,
        rowIndex: numberString-1,
      })
    }
    setEntityNumbers('')
  }
  return (
    <>
      <td >{r.numberString}</td>
      <td >{r.date}</td>
      <td style={{textWrap: 'nowrap'}}>{r.total}</td>
      <td>{r.counterparty || "Неопределено"}</td>
      <td>{r.comment}</td>
      <td>{
        process.env.REACT_APP_VERSION === "production" &&
        <div className={'d-flex align-items-center gap-2'}>
        <Form.Control
          name={'search'}
          defaultValue={entityNumbers}
          value={entityNumbers}
          onChange={(e) => setEntityNumbers(e.target.value)}
          type={'text'}
          placeholder="Номера"
        />
        <i className="fa fa-share pointer" onClick={()=>sendInfo(r)}/>

      </div>}</td>
    </>
  );
};

export default TransactionRow;
